import { render, staticRenderFns } from "./RoleIndex.vue?vue&type=template&id=152bc7a0&scoped=true"
import script from "./RoleIndex.vue?vue&type=script&lang=js"
export * from "./RoleIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "152bc7a0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('152bc7a0')) {
      api.createRecord('152bc7a0', component.options)
    } else {
      api.reload('152bc7a0', component.options)
    }
    module.hot.accept("./RoleIndex.vue?vue&type=template&id=152bc7a0&scoped=true", function () {
      api.rerender('152bc7a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/auth/role/RoleIndex.vue"
export default component.exports